import { ListItem, ListItemText } from "@mui/material";
import DragHandleIcon from "@mui/icons-material/DragHandle";

import { Widget } from "@/lib/api";

import * as styles from "./styles";

type Props = {
  item: Widget;
};

export default function TabItem({ item }: Props) {
  return (
    <ListItem component="div" sx={styles.listItem} secondaryAction={<DragHandleIcon />}>
      <ListItemText primary={item.title} />
    </ListItem>
  );
}
